import { config } from '../../app/config';
import { cn } from '../../lib/cn';

/**
 * Isotipo de ED Ecosystem.
 *
 * Dos formas, y nada mas:
 *
 *   - **En pila** (por defecto): el isotipo grande con la palabra debajo. Es
 *     la cabecera de la barra lateral y la de la pantalla de carga.
 *   - **`compact`**: solo el isotipo pequeno, para la barra superior del movil
 *     y para la barra lateral plegada, donde no caben ni ochenta pixeles de
 *     ancho ni una palabra.
 *
 * El archivo vive en `public/` y no se importa desde `src/`: asi Vite lo sirve
 * tal cual, con su nombre, y se puede cambiar el logotipo reemplazando el
 * archivo sin volver a compilar nada.
 *
 * Lleva fondo transparente, asi que se ve igual en claro y en oscuro. Por eso
 * NO se le pone recuadro de color: el isotipo ya trae su propia forma.
 */

/*
 * Aqui va el isotipo suelto con el nombre debajo, no el logotipo completo.
 *
 * El completo —el que lleva «ED Ecosystem» dibujado dentro— se usa en la
 * pantalla de ingreso, que es la primera que ve alguien y no trae ningun otro
 * texto que diga donde esta. Dentro del portal el nombre ya aparece en la
 * pestana y en la cabecera, asi que repetirlo dibujado ademas obligaria a
 * encoger el isotipo para que cupiera todo en la barra lateral.
 */
const PALABRA = config.appName;

export function Logo({
  compact = false,
  className,
}: {
  compact?: boolean;
  className?: string;
}): JSX.Element {
  if (compact) {
    return (
      <div className={cn('flex items-center justify-center', className)}>
        <img
          src="/ed-ecosystem-logo.png"
          alt=""
          aria-hidden
          width={36}
          height={36}
          // `object-contain` impide que una imagen que no sea cuadrada se
          // deforme para rellenar el hueco.
          className="h-9 w-9 shrink-0 object-contain"
        />
        <span className="sr-only">{config.appName}</span>
      </div>
    );
  }

  return (
    <div className={cn('flex flex-col items-center gap-2', className)}>
      <img
        src="/ed-ecosystem-logo.png"
        alt=""
        aria-hidden
        width={88}
        height={88}
        className="h-[88px] w-[88px] shrink-0 object-contain"
      />
      {/*
        Sin `sr-only` adicional: aqui el nombre ya esta escrito y se lee solo.
        Repetirlo en un span oculto lo anunciaria dos veces seguidas en
        cualquier lector de pantalla.
      */}
      <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-text-muted">
        {PALABRA}
      </span>
    </div>
  );
}
